(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["masonry-grid"] && !Shopify.designMode) return;
  try {
    var masonry_items = document.querySelectorAll('.masonry-box__item');
    masonry_items.forEach(item => {
      const n = (Math.random() * 400) + 70;
      item.style.setProperty('--width', n+'px');
    });
  } catch(e) { console.error(e); }
})();

})();
